import { render, staticRenderFns } from "./PrintDispatchSummary.vue?vue&type=template&id=971db40c&scoped=true"
import script from "./PrintDispatchSummary.vue?vue&type=script&lang=js"
export * from "./PrintDispatchSummary.vue?vue&type=script&lang=js"
import style0 from "./PrintDispatchSummary.vue?vue&type=style&index=0&id=971db40c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971db40c",
  null
  
)

export default component.exports